module.exports = __webpack_public_path__ + "media/images/athletes/1364-c69843d157e0f6ff711ad161ef782912.png";